// frontend/src/pages/supplierCatalogAssignResult.js
//
// What the Supplier catalog says after "Assign items" (bulk-create).

/**
 * The alert for a bulk-create response `{created, skipped_existing, rejected}`.
 *
 * `created` is the server's count, not the selection size: a row linked by
 * another session between listing and adding is skipped, and a priced row
 * that makes this supplier the item's default pushes its cost to Shopify
 * before it is written — a row Shopify rejected was not assigned. Saying only
 * "Assigned N" would hide it, so a rejection turns the alert into a warning.
 *
 * @returns {{message: string, severity: 'success'|'warning'}}
 */
export function assignResultAlert(data, t) {
  const assigned = data.skipped_existing
    ? t('supplierCatalog.assign.successSkipped', {
        count: data.created, skipped: data.skipped_existing })
    : t('supplierCatalog.assign.success', { count: data.created });
  if (!data.rejected) return { message: assigned, severity: 'success' };
  return {
    message: `${assigned} ${t('supplierCatalog.assign.rejected', { count: data.rejected })}`,
    severity: 'warning',
  };
}
